import React, { useState } from 'react';

const Notification = () => {
  const [notificationText, setNotificationText] = useState('');
  const [notificationSent, setNotificationSent] = useState(false);

  const handleInputChange = (e) => {
    setNotificationText(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Define your API endpoint where you want to send the notification
    const apiUrl = 'https://your-api-endpoint.com';

    // Create a data object to send to the API
    const data = { text: notificationText };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setNotificationSent(true);
      } else {
        // Handle any error responses from the API
        console.error('Failed to send notification');
      }
    } catch (error) {
      console.error('An error occurred while sending the notification', error);
    }
  };

  return (
    <section>
      <div className='container'>
        {/* <div className='row'> */}
          <div className='col-lg-8 bg-primary mt-4 mx-4'>
            <div className='text-white'>
              <h4>Notification</h4>
            </div>
          </div>
        {/* </div> */}
        <div className='row mt-2'>
          <div className='col-lg-8'>
            <form onSubmit={handleSubmit}>
              <div className='form-group mx-4'>
                <label htmlFor='notificationText'>Notification Text</label>
                <input
                  type='text'
                  className='form-control mt-2'
                  id='notificationText'
                  placeholder='Enter your notification text'
                  value={notificationText}
                  onChange={handleInputChange}
                />
              </div>
              <button type='submit' className='btn btn-primary mt-4 mx-4'>
                Send Notification
              </button>
            </form>
          </div>
        </div>
        {notificationSent && (
          <div className='row mt-2'>
            <div className='col-lg-12'>
              <div className='alert alert-success' role='alert'>
                Notification sent successfully!
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Notification;
